import React from 'react';
import ColorfulIcon from './ColorfulIcon';
import { products } from '../mockData';

const iconGradients = ['blue', 'purple', 'green', 'orange', 'teal', 'indigo', 'rose', 'amber'];

const Products = () => {
  return (
    <section id="products" className="py-6 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-6">
          <p className="text-blue-600 text-sm font-semibold tracking-wider uppercase mb-2" style={{ fontFamily: '-apple-system, BlinkMacSystemFont, SF Pro Text, sans-serif' }}>
            Product Catalog
          </p>
          <h2 className="text-4xl md:text-5xl font-semibold text-gray-900 mb-3" style={{ fontFamily: '-apple-system, BlinkMacSystemFont, SF Pro Display, sans-serif', letterSpacing: '-0.02em' }}>
            IT Products
          </h2>
          <p className="text-gray-600 text-lg max-w-3xl mx-auto" style={{ fontFamily: '-apple-system, BlinkMacSystemFont, SF Pro Text, sans-serif' }}>
            Boost your workspace with premium IT hardware from the world's leading brands
            — quality, innovation, and support in one place.
          </p>
        </div>

        {/* Products Grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
          {products.map((product, index) => {
            return (
              <div
                key={product.id}
                className="group bg-gray-50 hover:bg-white border border-gray-200 rounded-3xl p-6 hover:shadow-lg transition-all duration-300 hover:transform hover:scale-105 cursor-pointer"
              >
                <div className="flex flex-col items-center text-center">
                  <ColorfulIcon 
                    icon={product.icon} 
                    size={28} 
                    gradient={iconGradients[index % iconGradients.length]} 
                  />
                  <h3 className="text-lg font-semibold text-gray-900 mb-2 mt-3" style={{ fontFamily: '-apple-system, BlinkMacSystemFont, SF Pro Display, sans-serif' }}>{product.title}</h3>
                  <p className="text-gray-600 text-sm" style={{ fontFamily: '-apple-system, BlinkMacSystemFont, SF Pro Text, sans-serif' }}>{product.subtitle}</p>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default Products;